// extracted by mini-css-extract-plugin
export var active = "_mo-2";
export var recordingDot = "_mo-1";
export var recordingIndicator = "_mo-0";